module.exports = __webpack_public_path__ + "static/media/jm.73ca4999.svg";